// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;

  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
    margin: 30px 0;
  }
`;
const Image = styled.div`
  height: 105px;
  width: calc(100% - 274px);
  margin: 38px 137px 0 137px;
  float: left;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 105, 90, "vw")};
    margin: ${scale(1100, 767, 38, 19, "vw")} ${scale(1100, 767, 137, 69, "vw")}
      0 ${scale(1100, 767, 137, 69, "vw")};
    width: ${scale(1100, 767, 775, 579, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    height: 60px;
    margin: 0 0 30px 0;
  }
`;
const Body = styled.div`
  width: calc(100% - 274px);
  margin: 32px 137px 66px 137px;
  float: left;

  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.63;
  letter-spacing: 1.1px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    margin: ${scale(1100, 767, 32, 16, "vw")} ${scale(1100, 767, 137, 69, "vw")}
      ${scale(1100, 767, 66, 30, "vw")} ${scale(1100, 767, 137, 69, "vw")};
    width: ${scale(1100, 767, 775, 579, "vw")};

    font-size: ${scale(1100, 767, 16, 12, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
    font-size: 11px;
    line-height: 1.91;
    letter-spacing: 0.7px;
  }
`;
const Inner = styled.div`
  margin: 25px;
  float: left;
  width: calc(100% - 50px);
  background-color: #f9f9f9;
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 0;
    padding: 28px 23px 30px 23px;
  }
`;

class GrayBoxNoTitle extends ArticleAbstract {
  render() {
    return (
      <Wrapper>
        <Inner>
          <Image style={this.image()} />
          <Body>
            <FlatBody>{this.body()}</FlatBody>
          </Body>
        </Inner>
      </Wrapper>
    );
  }
}

export default GrayBoxNoTitle;



// WEBPACK FOOTER //
// ./src/components/GrayBoxNoTitle.js